module.exports = __webpack_public_path__ + "img/clubs-intro.06387151.jpg";